<script>
	import Vue from 'vue'

	const bsContainer = (el, binding) => {
		$(el).on('click', function(e) {

			//Get rid of any other tooltips (this attribute also applies to popovers)
			$('[data-original-title]').not(e.target).tooltip('hide');
		})
	}

	const bsTooltip = (el, binding) => {
		const t = []

		//console.log('doing work', binding);

		if (binding.modifiers.focus) t.push('focus')
		if (binding.modifiers.hover) t.push('hover')
		if (binding.modifiers.click) t.push('click')
		if (!t.length) t.push('hover')
		
		$(el).tooltip('dispose');
		
		$(el).tooltip({
			title: binding.value,
			placement: binding.arg || 'top',
			trigger: t.join(' '),
			html: !!binding.modifiers.html,
		});	
	}

	Vue.directive('tooltipContainer', {
		bind: bsContainer
	});

	export default Vue.directive('tooltip', {
		bind: bsTooltip,
		update: bsTooltip,
		unbind (el) {
			$(el).tooltip('dispose');
		}
	});

</script>


// WEBPACK FOOTER //
// src/directives/TooltipDirective.vue